import React from 'react';
import { connect } from 'react-redux';

import FigurePlates from './FigurePlates';
import Panel from '../../../../object-view/objects/panel';
import SquarePlates from '../../SquarePlates/index';
import StandOffs from './StandOffs';
import MaterialSelector from '../../../../components/MaterialSelector/index';

import './styles.scss';
import { setPanelType } from '@reducers/options/panel/actions';
import { setCircleScrews, setTriangleScrews } from '@reducers/options/screw/actions';
import {
  setSquareActiveBtn, setCircleActiveBtn, setTriangleActiveBtn,
  setProfileMaterial, setProfileFamily, setProfileSize
} from '@reducers/selectors/application/actions';
import { APP_TYPES } from '@config';
import { standardList } from '../../../../app.values';
import { setCustomCoordinates } from '@reducers/selectors/dimension/actions';
import ObjectOrientation  from './../../../Dimension/components/BasePlate/ObjectOrientation';

const GeneralCalculation = props => (
  <div className="calculation general-calculation">
    <div className="list-type">
      <SquarePlates
        buttons={props.squareButtons}
        activeBtn={props.activeSquareBtn || (props.activeEditorBtn ? "2DEditor" : null)}
        onUpdate={props.setSquareBtn}
      />

      {props.designStandard !== standardList['Masonry'] && (
        <FigurePlates
          options={props.options}
          buttons={props.circleButtons}
          activeBtn={props.activeCircleBtn}
          figureValue={props.options.screw.count.n}
          onClick={props.setCircle}
          specifyCoordinates={props.specifyCoordinates}
          setCustomCoordinates={props.setCustomCoordinates}
        />
      )}

      {props.designStandard !== standardList['Masonry'] && (
        <FigurePlates
          options={props.options}
          buttons={props.triangleButtons}
          activeBtn={props.activeTriangleBtn}
          figureValue={props.options.screw.count.n}
          onClick={props.setTriangle}
          specifyCoordinates={props.specifyCoordinates}
          setCustomCoordinates={props.setCustomCoordinates}
        />
      )}
    </div>
      
    <ObjectOrientation />

    <div className="list-type">
      <MaterialSelector
        material={props.profileMaterial}
        onMaterialSelect={props.onProfileMaterialSelect}
        family={props.profileFamily}
        onFamilySelect={props.onProfileFamilySelect}
        size={props.profileSize}
        onSizeSelect={props.onProfileSizeSelect}
      />
    </div>

    {props.designStandard !== standardList['Masonry'] && (
      <StandOffs/>
    )}
  </div>
);

const mapState = state => ({
  designStandard: +state.main.localization.designStandard,

  options: state.options,
  squareButtons: state.selectors.application.generalButtons.squareButtons,
  activeSquareBtn: state.selectors.application[APP_TYPES.GENERAL_CALCULATION].activeSquareBtn,

  circleButtons: state.selectors.application.generalButtons.circleButtons,
  activeCircleBtn: state.selectors.application[APP_TYPES.GENERAL_CALCULATION].activeCircleBtn,

  triangleButtons: state.selectors.application.generalButtons.triangleButtons,
  activeTriangleBtn: state.selectors.application[APP_TYPES.GENERAL_CALCULATION].activeTriangleBtn,

  activeEditorBtn: state.selectors.application[APP_TYPES.GENERAL_CALCULATION].activeEditorBtn,

  profileMaterial: state.selectors.application[APP_TYPES.GENERAL_CALCULATION].profile.material,
  profileFamily: state.selectors.application[APP_TYPES.GENERAL_CALCULATION].profile.family,
  profileSize: state.selectors.application[APP_TYPES.GENERAL_CALCULATION].profile.size,
  specifyCoordinates: (state.selectors.dimension[state.main.appType].basePlate && 
    state.selectors.dimension[state.main.appType].basePlate.spacing && 
    state.selectors.dimension[state.main.appType].basePlate.spacing.specifyCoordinates) || false
});

const mapDispatch = dispatch => ({
  setSquareBtn: btn => {
    dispatch(setSquareActiveBtn(btn.id));
  },
  setCircle: data => {
    dispatch(setPanelType(Panel.types.CIRCLE));
    if (data) {
      dispatch(setCircleScrews(data.count, data.id === '6' ? true : false));
    }

    dispatch(setCircleActiveBtn(data.id));
  },
  setTriangle: data => {
    dispatch(setPanelType(Panel.types.TRIANGLE));
    if (data && data.count) {
      if (typeof data.count === 'object') {
        dispatch(setTriangleScrews(data.count.n, data.count.m, data.count.k, data.id === '4' ? true : false));
      } else {
        dispatch(setTriangleScrews(data.count, data.count, data.count, data.id === '4' ? true : false));
      }
    }

    dispatch(setTriangleActiveBtn(data.id));
  },

  onProfileMaterialSelect: value => dispatch(setProfileMaterial(value)),
  onProfileFamilySelect: value => dispatch(setProfileFamily(value)),
  onProfileSizeSelect: value => dispatch(setProfileSize(value)),
  setCustomCoordinates: (value) => dispatch(setCustomCoordinates(value))
});

export default connect(mapState, mapDispatch)(GeneralCalculation);



// WEBPACK FOOTER //
// ./src/views/Application/types/GeneralCalculation/index.js